import type { ReactElement } from 'react';

import { Checkbox } from 'src/components/ui/checkbox';
import { Skeleton } from 'src/components/ui/skeleton';
import { ConfigurationCriteriaProductsSkeleton } from 'src/features/configuration/configurationCriteria/configurationCriteriaProducts/ConfigurationCriteriaProductsSkeleton';
import { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';

export function ConfigurationCriteriaSkeleton(): ReactElement {
  return (
    <div className='mt-1.5 flex w-full flex-col gap-10'>
      {Object.values(ConfigurationCriteriaEnum).map((criterionKey) => (
        <div
          className='flex w-full flex-wrap items-center gap-2 text-sm'
          key={criterionKey}
        >
          <Checkbox className='ml-2 size-5' disabled />
          <span>-</span>
          <Skeleton className='h-4 w-96' />
          <Skeleton className='h-4 w-14' />
        </div>
      ))}
      <ConfigurationCriteriaProductsSkeleton />
    </div>
  );
}
